{
	"adjustLabel": "Adjust: {{mode}}",
	"ariaSelectHslAdjustmentMode": "Select HSL Adjustment Mode",
	"blackWhiteMix": "Black & White Mix",
	"color": "Color",
	"colorAqua": "Aqua",
	"colorBlue": "Blue",
	"colorGreen": "Green",
	"colorMagenta": "Magenta",
	"colorOrange": "Orange",
	"colorPurple": "Purple",
	"colorRed": "Red",
	"colorYellow": "Yellow",
	"hsl": "HSL",
	"keyAll": "All",
	"keyHue": "Hue",
	"keyLuminance": "Luminance",
	"keySaturation": "Saturation",
	"panelHsl": "HSL"
}
